import { productIdFormat } from "@redotech/redo-ids-cockroach";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as zod from "zod";

export const priceAdjustmentType = createEnum(["percentage", "fixed"]);
export type PriceAdjustmentType = zod.infer<typeof priceAdjustmentType>;

export const roundingMode = createEnum([
  "none",
  "nearestDollar",
  "existingCents",
  "customCents",
]);
export type RoundingMode = zod.infer<typeof roundingMode>;

export const bulkUpdateProductPrices = {
  name: "bulkUpdateProductPrices" as const,
  input: zod.object({
    productIds: zod.array(productIdFormat.schema),
    adjustmentType: priceAdjustmentType,
    adjustmentValue: zod.number(),
    roundingMode,
    customCentsValue: zod.number().int().min(0).max(99).optional(),
  }),
  output: zod.object({ updatedCount: zod.number().int() }),
};
